/** @format */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

import * as serviceWorker from "./serviceWorker";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./apis";

import ChannelService from "./ChannelService";
import ReactGA from "react-ga4";

import StoresContext from "@stores/context";
import stores from "@src/stores";
import { Observer } from "mobx-react";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "@src/style/theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

ChannelService.boot({
  pluginKey: "8389f523-be2c-4c8d-ae20-67db4ad97667",
  mobileOpenUI: "iframe"
});
ReactGA.initialize("G-54NFE85CH5");

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <StoresContext.Provider value={stores}>
          <StoresContext.Consumer>
            {({ settings }) => (
              <Observer>
                {() => (
                  <ChakraProvider theme={theme}>
                    <App />
                  </ChakraProvider>
                )}
              </Observer>
            )}
          </StoresContext.Consumer>
        </StoresContext.Provider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
